/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputControlFrequency
 */
export interface InputControlFrequency {
    /**
     * 
     * @type {number}
     * @memberof InputControlFrequency
     */
    firstFrequency?: number;
    /**
     * 
     * @type {number}
     * @memberof InputControlFrequency
     */
    secondFrequency?: number;
    /**
     * 
     * @type {string}
     * @memberof InputControlFrequency
     */
    type: string;
}

/**
 * Check if a given object implements the InputControlFrequency interface.
 */
export function instanceOfInputControlFrequency(value: object): boolean {
    if (!('type' in value)) return false;
    return true;
}

export function InputControlFrequencyFromJSON(json: any): InputControlFrequency {
    return InputControlFrequencyFromJSONTyped(json, false);
}

export function InputControlFrequencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputControlFrequency {
    if (json == null) {
        return json;
    }
    return {
        
        'firstFrequency': json['firstFrequency'] == null ? undefined : json['firstFrequency'],
        'secondFrequency': json['secondFrequency'] == null ? undefined : json['secondFrequency'],
        'type': json['type'],
    };
}

export function InputControlFrequencyToJSON(value?: InputControlFrequency | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstFrequency': value['firstFrequency'],
        'secondFrequency': value['secondFrequency'],
        'type': value['type'],
    };
}

